<div class="browse-data-carousel">
  <h2 class="browse-data-heading">Browse data</h2>

  <div class="carousel-body">
    <button type="button" class="carousel-nav-btn carousel-nav-prev"
      (click)="prev()" [disabled]="pageIndex === 0" aria-label="Previous cards">
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <path d="M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z" fill="#FFFFFF"/>
      </svg>
    </button>

    <div class="carousel-viewport">
      <div class="carousel-track" [style.transform]="'translateX(-' + trackOffset + 'px)'">
        @for (category of categories; track category.categorySlug; let i = $index) {
          <div class="carousel-slide" (focusin)="onCardFocus(i)">
            <app-portal-card
              [title]="category.title"
              [entriesCount]="category.entriesCount"
              [description]="category.description"
              [accentColor]="category.accentColor"
              [categorySlug]="category.categorySlug">
            </app-portal-card>
          </div>
        }
      </div>
    </div>

    <button type="button" class="carousel-nav-btn carousel-nav-next"
      (click)="next()" [disabled]="pageIndex >= dots.length - 1" aria-label="Next cards">
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <path d="M8.59 16.59L10 18l6-6-6-6-1.41 1.41L13.17 12z" fill="#FFFFFF"/>
      </svg>
    </button>
  </div>

  @if (categories.length > 1) {
    <div class="carousel-pagination">
      @for (category of categories; track category.categorySlug; let i = $index) {
        <button type="button" class="carousel-dot" [hidden]="i >= dots.length" [class.active]="i === pageIndex"
          (click)="goToPage(i)" [attr.aria-label]="'Go to page ' + (i + 1)">
        </button>
      }
    </div>
  }
</div>
